// These fields allign with /CRDataNode/?qualifier=type.identifier='Wage rate unit' AND deleted=0 AND notActive=0
// values match CRDataNode 'value' property => important for matching on the backend

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();const salaryPeriodNodes = ['per dag', 'per week', 'per maand', 'per uur'] as const;

export type SalaryPeriodNode = (typeof salaryPeriodNodes)[number];

export const salaryPeriodOptions: {
  value: SalaryPeriodNode;
  labels: { language: 'nl' | 'fr' | 'en'; label: string }[];
}[] = [
  {
    value: 'per dag',
    labels: [
      { language: 'nl', label: 'per dag' },
      { language: 'fr', label: 'par jour' },
      { language: 'en', label: 'per day' },
    ],
  },

  {
    value: 'per week',
    labels: [
      { language: 'nl', label: 'per week' },
      { language: 'fr', label: 'par semaine' },
      { language: 'en', label: 'per week' },
    ],
  },

  {
    value: 'per maand',
    labels: [
      { language: 'nl', label: 'per maand' },
      { language: 'fr', label: 'par mois' },
      { language: 'en', label: 'monthly' },
    ],
  },

  {
    value: 'per uur',
    labels: [
      { language: 'nl', label: 'per uur' },
      { language: 'fr', label: 'par heure' },
      { language: 'en', label: 'per hour' },
    ],
  },
];

export default salaryPeriodNodes;
